import React, { Component } from 'react'
import classnames from 'classnames'
import styles from './styles/button.scss'

export default class Button extends Component {
  render() {
    const {
      text,
      onClick,
      disabled = false,
      className = '',
      tabIndex = -1,
      warning = false,
      style
    } = this.props

    return (
      <button
        className={classnames(styles.button, { [styles.buttonWarning]: warning }, className)}
        onClick={onClick}
        disabled={disabled}
        tabIndex={tabIndex}
        style={style}
      >
        {text}
      </button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Button.js